import axiosClient from "./axiosClient.js";

const pipelineStageApi = {
  getByAccountId: (accountId) => {
    const url = `/pipeline-stages/getByAccountId/${accountId}`;
    return axiosClient.get(url);
  },
  getByShopId: (shopId, accountId) => {
    const url = `/pipeline-stages/getByShopId/${shopId}?accountId=${accountId}`;
    return axiosClient.get(url);
  },
  create: (data) => {
    const url = `/pipeline-stages/create`;
    return axiosClient.post(url, data);
  },
  updateById: (id, data) => {
    const url = `/pipeline-stages/update/${id}`;
    return axiosClient.put(url, data);
  },
  updateByIds: (data) => {
    const url = `/pipeline-stages/updateByIds`;
    return axiosClient.put(url, data);
  },
  softDeleteById: (id) => {
    const url = `/pipeline-stages/delete/${id}`;
    return axiosClient.delete(url);
  },
};

export default pipelineStageApi;
